<template>
    <div
        class="  w-full bg-black  px-6 py-3 z-10 flex flex-row justify-between items-center"
    >
        <div class="flex flex-row justify-start items-center">
            <div
                class="rounded-full h-8 w-8 border-2 border-white flex items-center justify-center cursor-pointer mr-10"
                @click="$emit('previousPage')"
            >
                <simple-arrow-icon
                    :fillClass="'fill-white'"
                    class="transform -rotate-90 mr-0.5"
                />
            </div>
            <slot />
            <div
                class="rounded-full h-8 w-8 border-2 border-white flex items-center justify-center cursor-pointer ml-10"
                @click="$emit('nextPage')"
            >
                <simple-arrow-icon
                    :fillClass="'fill-white'"
                    class="transform rotate-90 ml-0.5"
                />
            </div>
        </div>
        <div class="flex gap-5">
            <div class="flex flex-row justify-start items-center">
                <div
                    class="rounded-full h-8 w-8 border-2 border-white flex items-center justify-center cursor-pointer mr-2"
                    @click="$emit('zoomOut')"
                >
                    <p class="text-white text-2xl">-</p>
                </div>
                <div
                    class="rounded-full h-8 w-8 border-2 border-white flex items-center justify-center cursor-pointer ml-2"
                    @click="$emit('zoomIn')"
                >
                    <p class="text-white text-2xl">+</p>
                </div>
            </div>
            <div
                class="h-8 w-8 flex items-center justify-center cursor-pointer"
                @click="$emit('toggleFullScreen')"
            >
                <zoom-in-icon
                    v-if="isFullScreen == false"
                    :fillClass="'fill-white'"
                />
                <zoom-out-icon v-else :fillClass="'fill-white'" />
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";
import SimpleArrowIcon from "../../../../../components/icons/SimpleArrowIcon.vue";
import ZoomInIcon from "../../../../../components/icons/ZoomInIcon.vue";
import ZoomOutIcon from "../../../../../components/icons/ZoomOutIcon.vue";
export default defineComponent({
    name: "PdfActions",
    components: { SimpleArrowIcon, ZoomInIcon, ZoomOutIcon },
    emits: [
        "previousPage",
        "nextPage",
        "toggleFullScreen",
        "zoomIn",
        "zoomOut",
    ],
    props: {
        isFullScreen: {
            type: Boolean,
            required: true,
        },
    },
});
</script>
